/* global fbq */
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import LottieAnimation from "vue3-lottie";
import mitt from "mitt";
import { createPinia } from "pinia";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const vuetify = createVuetify({
  components,
  directives,
  rtl: true,
  theme: {
    defaultTheme: "light",
    themes: {
      light: {},
      dark: {},
    },
  },
});

router.afterEach((to) => {
  if (typeof fbq === "function") {
    fbq("track", "PageView");

    if (to.name === "SpecificRouteName") {
      fbq("track", "CustomEventName", { customParam: "value" });
    }
  }
});

createApp(App)
  .use(vuetify)
  .use(LottieAnimation)
  .provide("Emitter", mitt())
  .use(createPinia())
  .use(router)
  .mount("#app");
